import styled from 'styled-components';

export const TransactionsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;

  thead {
    text-transform: uppercase;
    font-size: 12px;
    color: var(--color-text-muted);
    border-bottom: 1px solid #e2e8f0;
  }

  th,
  td {
    padding: 10px 0;
    text-align: left;
    vertical-align: middle;
  }

  tbody tr + tr {
    border-top: 1px solid #eef2ff;
  }

  small {
    color: var(--color-text-muted);
  }
`;
